export class Menu {
    path: string;
    text: string;
    defaultPath: string;
    constructor(path, text, defaultPath) {
        this.path = path;
        this.text = text;
        this.defaultPath = defaultPath;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/app/class/menu.ts